import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button } from './ui'

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const hasConsented = localStorage.getItem('qr-app-cookies-consented')
    if (!hasConsented) {
      setShowBanner(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('qr-app-cookies-consented', 'true')
    setShowBanner(false)
  }

  const handleDecline = () => {
    localStorage.setItem('qr-app-cookies-consented', 'false')
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-slate-900/95 dark:bg-slate-950/95 backdrop-blur-md text-white rounded-2xl shadow-modern-lg border border-slate-700/50 px-4 py-3 sm:px-6 sm:py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-sm text-slate-300 flex-1">
            We use cookies to enhance your experience.{' '}
            <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline">
              Learn more
            </Link>
          </p>
          <div className="flex gap-2 shrink-0">
            <Button variant="ghost" size="sm" onClick={handleDecline} className="text-slate-300 hover:text-white hover:bg-slate-700">
              Decline
            </Button>
            <Button variant="primary" size="sm" onClick={handleAccept}>
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
